/* eslint-disable import/prefer-default-export */
import { createTheme, lighten } from '@material-ui/core/styles';
import background from '../assets/img/background/firmaYa.jpg';
import logo from '../assets/img/logo/firmaYa.svg';
import MuliFont from '../assets/font/muli_font/Muli-Light.ttf';

const muli = {
  fontFamily: 'Muli-Light',
  fontStyle: 'normal',
  fontDisplay: 'swap',
  fontWeight: 400,
  src: `
    local('Muli-Light'),
    local('Muli-Light'),
    url(${MuliFont}) format('ttf')
  `,
  unicodeRange:
    'U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF',
};

export default createTheme({
  app: {
    favicon: 'firmayaIco.ico',
    title: 'firmaya',
  },
  palette: {
    primary: {
      main: '#E55200',
    },
    secondary: {
      main: '#E55200',
    },
    error: {
      main: '#d61103',
    },
  },
  typography: {
    fontFamily: 'Muli, Arial',
    fontSize: 13,
  },
  panelSummary: {
    color: 'white',
    backgroundColor: '#E55200',
  },
  resendEmailLink: {},
  verifyEmailLink: {},
  checkOptionFilter: {},
  checkOptionHover: {},
  switchBase: {
    main: '#9e9e9e',
    track: '#fff',
    checked: '#fff',
    selectTrack: '#E55200',
  },
  logo,
  styleLogo: {
    zIndex: 1,
  },
  colorHeader: '#F1F1F1',
  header: {
    usserLogged: {
      color: '#4B4B4B',
    },
  },
  leftMenu: {
    backgroundColor: '',
    color: '',
  },
  home: {
    paquetes: {
      backgroundColor: '#F6F6F6',
    },
    combos: {
      backgroundColor: '#FFEFD8',
      border: '1px solid #ED8D3D',
    },
    agregados: {
      backgroundColor: '#F6F6F6',
      border: '1px solid #B2B2B2',
    },
    backgroundSliderCard: {
      color: 'rgb(255, 255, 255, 0.1)',
    },
    bgColorHead: {
      bases:
        'orange,orange01,orange02,orange,orange01,orange02,orange,orange01,orange02,orange,orange01,orange02',
      combos: 'orange04',
      arrayComplementary:
        '1,2,3,4,1,2,3,4,1,2,3,4,1,2,3,4,1,2,3,4,1,2,3,4,1,2,3,4,1,2,3,4,1,2,3,4,1,2,3,4,1,2,3,4,1,2,3,4,1,2,3,4',
      complement: 'red',
      complementaryMyplan: 'orange01',
    },
    sliderComboText: {},
    sliderComplementText: {},
    sliderComplementaryButtonColor: {
      color: '#EDEDED',
    },
    sliderComplementaryButtonTextColor: {
      color: '#F44236',
    },
    sliderBackGroundColor: {},
    sliderArrow: {},
    shoppingCart: {
      color: '#4F4F4F',
    },
    cart: {
      dialogTitle: {},
      dialogContent: {},
      title: {
        color: '#E55200',
      },
      tableHead: {
        backgroundColor: '#FFEFD8',
      },
      cardList: {},
      checkIconBox: {
        width: 15,
        height: 15,
        stroke: '#2cc63e',
      },
      listItem: {},
      discountText: {
        color: '#575756',
      },
      infoDescountTextResponsive: {
        color: '#575756',
      },
      totalText: {
        color: '#4F4F4F',
      },
      promoForm: {
        backgroundColor: '#F1F1F1',
        color: '#B2B2B2',
        borderRadius: 5,
      },
      promoFormNoResponsive: {
        backgroundColor: '#F1F1F1',
        color: '#B2B2B2',
        borderRadius: 5,
      },
      slider: {},
      quantityPackage: {},
      quantityPackageResponsive: {},
      dividerMiddle: {},
      listDividerBottom: {},
      btnPromotional: {
        backgroundColor: '#F5AE19',
      },
      btnPromotionalResponsive: {
        backgroundColor: '#FFF',
        color: '#E55200',
        border: '1px solid',
      },
      btnCancelResponsive: {
        backgroundColor: '#FFF',
        color: '#E55200',
        border: '1px solid',
      },
      tableCell: {
        color: '#E55200',
      },
      rowCell: {},
      colorItem: {},
      listItemPopover: {},
      dividerPopover: {},
      textPromotional: {
        backgroundColor: '#fff',
      },
      colorTextPromotional: {},
      colorNumberQuantity: {},
      btnContinue: {
        fontSize: 14,
      },
      btnContinueResponsive: {},
      btnAddPackages: {
        backgroundColor: '#fff',
        color: '#E55200 !important',
        border: '2px solid #E55200 !important',
        float: 'right',
        '&:hover': {
          backgroundColor: '#FEECD4',
        },
      },
      summaryCart: {
        backgroundColor: '#FFFFFF',
      },
      tableCellNoItems: {},
      subtotalText: {
        color: '#E96F2C',
      },
      btnGoToCart: {
        backgroundColor: '#E77F01',
      },
      btnRemoveFromCart: {
        color: '#E5521A',
      },
      detailPackage: {
        backgroundColor: '#F4F4F4',
      },
      iconShoppingCart: {
        iconShoppingCart: {
          fill: '#CCCCCC',
          '& .b, .c': {
            stroke: '#CCCCCC',
          },
        },
      },
      hoverAddProducts: {
        backgroundColor: '#F1F1F1',
      },
      titleDetail: {
        color: '#E55200',
      },
      seeMore: {
        color: '#E55200',
      },
      seeLess: {
        color: '#E55200',
      },
      span: {
        color: '#4F4F4F',
      },
      spanResposive: {},
      borderColor: {
        background: '#FFFFFF2E',
        border: '1px solid #D6D6D6',
      },
      customBadge: {},
      customBadgeItems: 'white',
      helpIconColor: {},
      helpIconColorLicense: {
        color: '#FFFFFF',
      },
      backgroundDialogResponsive: {},
      titleHeader: {},
      deleteIconFromCart: {},
      quantityActionCart: {
        color: '#E55200',
      },
      typographyCard: {},
      moreLessButton: {
        color: '#2CC63E',
      },
      spacingContent: {},
      itemListStyles: {},
      itemListTextStyle: {
      },
    },
  },
  miplan: {
    bgColorCards: {},
    appBgColorCards: {
      boxShadow: 'none',
    },
    rootCard: {},
    title: {
      color: '#E55200',
      marginTop: '-10px',
    },
    subtitle: {
      color: '#6D6E72',
    },
    cardHeader: {
      color: '#E55200',
    },
    featureName: {},
    featureValue: {
      color: '#E55200',
    },
    buttonCard: {
      color: '#fff',
      backgroundColor: '#E45400',
    },
    hoverButtonCard: {
      color: '#fff',
      backgroundColor: '#F5AE19',
    },
    iconCard: {
      color: '#E55200',
    },
    btnDirectPlan: {
      backgroundColor: '#EA4519',
      color: '#FFFFFF',
      '&:hover': {
        backgroundColor: '#f57c00',
      },
    },
    circularColor: {
      color: '#FFFFFF',
    },
    tablePlanTable: {
      color: '#E55200',
      backgroundColor: '#FFEFD8',
      fontWeight: 700,
    },
    tableCellPlanTable: {
      color: '#000000',
      backgroundColor: '#FFFFFF',
      fontSize: 14,
      fontWeight: 500,
      '&:last-child': {
        borderTop: '1px solid #D6D6D6',
        borderBottom: '1px solid #D6D6D6',
        borderRight: '1px solid #D6D6D6',
        borderTopRightRadius: '10px',
        borderBottomRightRadius: '10px',
      },
      '&:first-child': {
        borderTop: '1px solid #D6D6D6',
        borderBottom: '1px solid #D6D6D6',
        borderLeft: '1px solid #D6D6D6',
        borderTopLeftRadius: '10px',
        borderBottomLeftRadius: '10px',
      },
      '&:nth-child(2)': {
        borderTop: '1px solid #D6D6D6',
        borderBottom: '1px solid #D6D6D6',
      },
    },
    purchasedPlans: {
      color: '#E55200',
      fontWeight: 700,
    },
    plansTypography: {
      color: '#4F4F4F',
    },
    spanPlanTable: {
      color: '#F5AE19',
    },
    reportIcon: {
      color: '#F5AE19',
    },
  },
  registerForm: {
    masterContainer: {},
    containerForm: {
      titleForm: {
        color: '#FFFFFF',
      },
    },
    activatePlan: {
      buttonActivate: {
        backgroundColor: '#E75200',
        color: '#fff',
      },
      policyAndTerms: {
        color: '#E55200',
      },
    },
    btnCancel: {},
    btnCancelNormal: {},
    btnResponsive: {},
    goHomeLink: {},
    titleForm: {},
    contentTextSecondary: {
      main: '#E55200',
    },
    typeInput: {
      position: 'relative',
      borderRadius: '4px',
    },
    colorLabelFocus: {},
    colorLabel: '',
    colorInputError: '',
    checkDigit: {
      main: '#E55200',
    },
    typeInputValidationCode: {},
    colorLabelValidationCode: '',
    colorBorderNormalValidationCode: {},
    selectIcon: {},
    cashIcon: {
      color: '#FFFFFF',
    },
    creditCardIcon: {
      color: '#FFFFFF',
    },
  },
  statusLicense: {
    containerMessage: {
      backgroundColor: 'white',
    },
    titleStatusLicense: {
      color: '#E55200',
    },
    summaryOrderPapper: {
      backgroundColor: '#FFFCF8',
    },
    buttonAction: {
      backgroundColor: '#F5AE19',
      color: '#fff',
      '&:hover': {
        backgroundColor: '#FF871E',
      },
    },
    appoveLicense: {},
    detailStatus: {
    },
  },
  alertPopup: {
    iconClose: {
      color: '#F5AE19',
    },
    titleAlert: {
      color: '#E55200',
    },
    buttonCancel: {
      backgroundColor: '#F5AE19',
      color: '#fff',
      '&:hover': {
        backgroundColor: '#E55200',
      },
    },
    buttonAccept: {
      backgroundColor: '#F5AE19',
      color: '#fff',
      '&:hover': {
        backgroundColor: '#E55200',
      },
    },
    secondaryMessageText: {
      color: '#c3c3c3',
    },
    mensajeModalMain: {},
  },
  summaryOrder: {
    loadFiles: {
      backgroundColor: '#F5F3F2',
      color: '#E65807',
    },
    totalPurchase: {
      color: '#E65705',
    },
    tableCellSummaryOrder: {},
    purchaseSummary: {},
    attachReceiptButtons: {
      color: '#E55200',
      borderColor: '#E55200',
    },
    textSummaryOrder: {
      '&.MuiTypography-h4': {
        marginLeft: 20,
        fontWeight: 'bold',
      },
    },
    purchaseEmpty: {
      '&.MuiTypography-body1': {
        marginBottom: 10,
        fontWeight: 500,
      },
    },
    formLabelColor: {
      color: 'var(--unnamed-color-575756)',
    },
    linearProgress: {
      backgroundColor: lighten('#FFFFFF', 0.5),
    },
    progressBarBackgroundColor: '#009BDD',
    dividerStyles: {},
    goHome: {},
  },
  backOffice: {
    configurations: {
      title: {
        color: '#003582',
      },
      editIcon: {
        color: '#009BDD',
      },
    },
  },
  helpToolTip: {
    root: {
      backgroundColor: '#E77F01',
      color: '#121212',
    },
  },
  overrides: {
    MuiButton: {
      root: {
        textTransform: 'none',
      },
      label: {
        fontWeight: 'bold',
      },
    },
    MuiCssBaseline: {
      '@global': {
        body: {
          background: `url(${background}) no-repeat center center fixed`,
          WebkitBackgroundSize: 'cover',
          MozBackgroundSize: 'cover',
          OBackgroundSize: 'cover',
          backgroundSize: 'cover',
        },
        '@font-face': [muli],
      },
    },
  },
});
